import React from 'react'
import invoice from '../../assets/images/invoiceborder.png'
import './invoice.css'
import ButtonDahbaord from 'components/ButtonDahbaord/ButtonDahbaord'
import { purple } from '@mui/material/colors'
import { formatDate,formatTimeInTimezone } from 'pages/utils/formdatedynamics'
import { getReadableOrderId } from 'pages/utils/HelperFun'
const Invoice = ({textInvoice,btnPurple,btnTranspraent,buttonClick,item}) => {
  return (
    <div className='main-invoice-div'>
        <div className='row-invoice'>
            <div className='row-invoice' style={{justifyContent:'flex-start'}}>
<img src={invoice} style={{width:'18%'}}/>
<div className='div-text-image-immer-text'>
    <h5 className='h5-heaidng-invouice'> {textInvoice}</h5>
    <p className='paragph-heading'>{formatDate(item?.paidAt)} || {formatTimeInTimezone(item?.paidAt)}</p>
</div>
            </div>
            <div className='btn-both'>
            <ButtonDahbaord handleclick={buttonClick} textButton={btnTranspraent} height={29} width={80} background={purple}/>
            {/* <ButtonDahbaord textButton={btnPurple} height={29} width={80} background='purple' /> */}
                
                </div>
        </div>
    </div>
  )
}

export default Invoice